import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { useLivekitEnabled } from 'v2/shared/hooks/use-livekit-enabled'

// Whether the Vibe Agent panel should be hidden on this builder — the feature
// flags always decide. `?onb=` (onboarding-launched builders) deliberately does
// NOT override this: every org that can see the onboarding banners already
// passes these gates (banner cutoff 2026-07-31 postdates the LiveKit
// auto-enable cutoff 2026-04-27), so an override could only ever re-enable
// Buddy for orgs where the kill-switch was deliberately flipped — via a
// bookmarkable URL param, and only for the flag sites that read it. The
// onboarding banner hides its Buddy CTAs behind this same hook instead, so
// nobody is offered a path the flags would close.
export const useVibeAgentHidden = (): boolean => {
  const { vibeAgentDisabled } = useFeatureFlags()
  const { isLivekitEnabled } = useLivekitEnabled()
  return vibeAgentDisabled || !isLivekitEnabled
}
